import { useEffect, useRef, useState } from 'react'

function getTypingInterval(charCount) {
  if (charCount > 800) return 6
  if (charCount > 400) return 10
  if (charCount > 150) return 14
  return 18
}

export default function useTypewriter(
  text,
  active,
  { onComplete, onTick } = {},
) {
  const [displayed, setDisplayed] = useState(active ? '' : text)
  const onCompleteRef = useRef(onComplete)
  const onTickRef = useRef(onTick)

  onCompleteRef.current = onComplete
  onTickRef.current = onTick

  useEffect(() => {
    if (!active) {
      setDisplayed(text)
      return undefined
    }

    const content = String(text || '')
    setDisplayed('')

    if (!content) {
      onCompleteRef.current?.()
      return undefined
    }

    let index = 0
    const intervalMs = getTypingInterval(content.length)

    const timer = window.setInterval(() => {
      index += 1
      setDisplayed(content.slice(0, index))
      onTickRef.current?.()

      if (index >= content.length) {
        window.clearInterval(timer)
        onCompleteRef.current?.()
      }
    }, intervalMs)

    return () => window.clearInterval(timer)
  }, [text, active])

  return displayed
}
